export class UploadFileRequest{
 public fileContent!: string
}
